import { Settings2 } from "lucide-react";
import { COMMUNITY_NAME } from "@/config";

const LEGAL = [
  { label: "Aviso legal", href: "#" },
  { label: "Política de privacidad", href: "#" },
  { label: "Política de cookies", href: "#" },
  { label: "Términos de la suscripción", href: "#" },
  { label: "Normas de la comunidad", href: "#normas" },
];

export const Footer = () => (
  <footer className="bg-[#0B1120] px-5 py-14">
    <div className="mx-auto grid max-w-[1100px] grid-cols-1 gap-10 md:grid-cols-3">
      <div>
        <p className="font-[Fraunces] text-lg font-semibold text-[#F5F1EA]">
          {COMMUNITY_NAME}
        </p>
        <p className="mt-2 text-sm leading-relaxed text-[#9AA6BE]">
          Un lugar donde puedes decir todo lo que pasa por tu mente y encontrar
          personas que realmente entienden cómo funciona.
        </p>
      </div>
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#6B7690]">
          Contacto
        </p>
        <ul className="mt-4 space-y-3">
          <li>
            <a
              data-testid="footer-mi-cuenta"
              href="/mi-cuenta"
              className="inline-flex items-center gap-2 text-sm text-[#9AA6BE] transition-colors hover:text-[#8B7CF6]"
            >
              <Settings2 className="h-4 w-4" strokeWidth={1.5} /> Gestionar o
              cancelar mi suscripción
            </a>
          </li>
        </ul>
      </div>
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#6B7690]">
          Legal
        </p>
        <ul className="mt-4 space-y-3">
          {LEGAL.map((l) => (
            <li key={l.label}>
              <a
                data-testid={`footer-legal-${l.label.toLowerCase().replaceAll(" ", "-")}`}
                href={l.href}
                className="text-sm text-[#9AA6BE] transition-colors hover:text-[#8B7CF6]"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
    <div className="mx-auto mt-12 max-w-[1100px] border-t border-[#22304D] pt-6 text-center">
      <p className="text-xs text-[#6B7690]">
        © 2026 {COMMUNITY_NAME} · Espacio de conversación y apoyo entre
        miembros. No es terapia ni un servicio sanitario.
      </p>
    </div>
  </footer>
);
